export default "__VITE_ASSET__C5Mp57jq__"